module.exports = __webpack_public_path__ + "img/htkj_01.9ad577a7.jpg";